import React, { useState, useEffect } from "react";
import "./bookappointment.css";
import Modal from "../modal/Modal";

import { useRef } from "react";
import BookingInfos from "../form/BookingInfos";
import { useSearchParams } from "react-router-dom";

const BookAppointment = ({ name }) => {
  const [searchParams] = useSearchParams();
  const search = searchParams.get("q");
  console.log(search);
  const ModalRef = useRef();

  const [showModal, setShowModal] = useState(false);
  console.log("button");
  const handleShowModal = () => {
    setShowModal(true);
  };

  useEffect(() => {
    // Show the modal if search is not null
    if (search !== null) {
      ModalRef.current.openModal();
    }
  }, [search]);
  return (
    <>
      <button
        className="NavButton text-center  hover:scale-90 mobileBtn"
        onClick={() => ModalRef.current.openModal()}
        // onClick= {handleShowModal}
      >
        {name}
      </button>
      {/* {
        showModal && 
       
          <BookingInfos setShowModal={setShowModal}/>

       
      } */}
      <Modal ref={ModalRef}>
        <BookingInfos />
      </Modal>
    </>
  );
};

export default BookAppointment;
